import React from 'react';
import { Magazine } from '../../components/Magazine';

export const data = {
  main: {
    title: 'Переехать за город и не пожалеть: плюсы и минусы собственного дома',
    imageUrl: 'https://images-cdn.cian.site/realty/journal/323760/zagorod.jpg',
    url: '/stati-pereehat-za-gorod-i-ne-pozhalet-pljusy-i-minusy-sobstvennogo-doma-323760/',
  },
  articles: [
    {
      title: 'Выбираем жилье: как не оказаться у свалки или МСЗ',
      caption: 'Экологические карты и советы экологов: мы собрали для вас самое полезное в одной статье.',
      imageUrl: 'https://images-cdn.cian.site/realty/journal/292235/Photogenica-PHX72511999.jpg',
      url: '/stati-vybiraem-zhile-kak-ne-okazatsja-u-svalki-ili-msz-292235/',
    },
    {
      title: 'Как не разориться зимой на отоплении загородного дома',
      caption:
        'Некоторые платят десятки тысяч рублей в месяц за электроэнергию. Другие — сотню рублей. От чего зависит размер счета? Циан.Журнал изучил различные примеры.',
      imageUrl: 'https://images-cdn.cian.site/realty/journal/322216/otoplenie_NmFjnSH.jpg',
      url: '/stati-kak-ne-razoritsja-zimoj-na-otoplenii-zagorodnogo-doma-322216/',
    },
    {
      title: 'Одноэтажная Россия: невысокие дома набирают популярность',
      caption:
        'Одноэтажные загородные дома в нашей стране долго воспринимались как свидетельство скромных финансовых возможностей хозяев. Ситуация изменилась за последние несколько лет.',
      imageUrl: 'https://images-cdn.cian.site/realty/journal/321741/623297.jpg',
      url: '/stati-odnoetazhnaja-rossija-nevysokie-doma-nabirajut-populjarnost-321741/',
    },
  ],
};

export const MagazineContainer = () => {
  return <Magazine {...data} />;
};
